var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}}),_c('Site',{attrs:{"msg":"Sample Slot using Vue.js/ PIXI.js/ ES6 "}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }